<template>
  <b-card v-if="data" text-variant="center" class="card card-congratulations">
    <!-- images -->
    <b-img
      :src="require('@/assets/images/elements/decore-left.png')"
      class="congratulations-img-left"
    />
    <b-img
      :src="require('@/assets/images/elements/decore-right.png')"
      class="congratulations-img-right"
    />
    <!--/ images -->

    <b-avatar variant="primary" size="70" class="shadow mb-2">
      <feather-icon size="28" icon="AwardIcon" />
    </b-avatar>
    <h1 class="mb-1 mt-50 text-white">Congratulations {{ data.name }},</h1>
    <b-card-text class="m-auto w-75">
      You have done 50% of registration. Now complete the registration by
      clicking on following button.
    </b-card-text>
    <b-button
      variant="primary"
      class="shadow my-2 btn-lg"
      @click="completeRegistration"
      >Complete Registration</b-button
    >
  </b-card>
</template>

<script>
import { BCard, BImg, BAvatar, BCardText, BButton } from "bootstrap-vue";
import router from "@/router";

export default {
  components: {
    BCard,
    BAvatar,
    BImg,
    BCardText,
    BButton,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    completeRegistration() {
      router.push({ name: "dashboard-complete-registration" });
    },
  },
};
</script>
